import { getAll } from "@/actions/setting.action";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentComponent from "./ContentComponent";
import { useMeta } from "@/context/MetaContext";
import { logger } from "@/lib/default-logger";

export default function AboutOnlineEducation() {
  const dispatch = useDispatch();
  const { setMeta } = useMeta();
  const { settings, status } = useSelector((state: any) => state.settings);
  const [about, setAbout] = useState<any>(null);
  useEffect(() => {
    if (status === "idle") {
      dispatch(getAll() as any);
    }
  }, [status, dispatch]);

  useEffect(() => {
    const about = settings.find(
      (setting: any) => setting.key === "aboutOnlineEducation"
    );
    if (settings) {
      logger.log(about?.value);
      setAbout(about?.value);
    }
  }, [settings]);

  useEffect(() => {
    setMeta({
      title: about?.title + " - Say&co Online",
      description:
        "Online Atölye platformumuz Say&co Online ile hedeflerinize daha hızlı ulaşabilir. Kariyer basamaklarını hızla tırnamana bilirsiniz",
      keywords: ["say&co online", "online", "atölye", "kariyer"],
      image: "/logo.png",
    });
  }, [setMeta, about]);

  return (
    <div className="w-full justify-items-center">
      <ContentComponent about={about} />
    </div>
  );
}
